import { combineReducers } from 'redux';

import { RootAction } from '..';
import { AppState } from '../rootReducer';
import {
  NEW_VERSION_AVAILABLE,
  NOTIFICATION_RECEIVED,
  NOTIFICATION_REMOVED,
  NOTIFICATION_SUBSCRIBE,
  UPDATE_SERVICE_WORKER,
  UPDATE_SERVICE_WORKER_SUCCESS,
} from './actionTypes';

export interface NotificationState {
  show: boolean;
  title: string;
  body: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
  isListening: boolean;
}

const emptyNotification = {
  show: false,
  title: '',
  body: '',
};

const initialState: NotificationState = {
  ...emptyNotification,
  isListening: false,
};

const notificationsReducer = (
  state = initialState,
  action: RootAction,
): NotificationState => {
  switch (action.type) {
    case NOTIFICATION_RECEIVED:
      return { ...state, ...action.payload, show: true };
    case NOTIFICATION_REMOVED:
      return { ...state, ...emptyNotification };
    case NOTIFICATION_SUBSCRIBE:
      return { ...state, isListening: true };
    default:
      return state;
  }
};

type ServiceWorkerState = {
  isNewVersionAvailable?: boolean;
  registration?: ServiceWorkerRegistration;
  isUpdating?: boolean;
};

export const serviceWorkerReducer = (
  state = {},
  action: RootAction,
): ServiceWorkerState => {
  switch (action.type) {
    case NEW_VERSION_AVAILABLE:
      return { ...state, isNewVersionAvailable: true, registration: action.payload.reg };
    case UPDATE_SERVICE_WORKER:
      return { ...state, isUpdating: true };
    case UPDATE_SERVICE_WORKER_SUCCESS:
      return { ...state, isUpdating: false };
    default:
      return state;
  }
};

export const notificationReducer = combineReducers({
  notifications: notificationsReducer,
  serviceWorker: serviceWorkerReducer,
});

// selectors
export const getNotifications = (state: AppState) => state.notification.notifications;

export const getIsNewVersionAvailable = (state: AppState) =>
  state.notification.serviceWorker.isNewVersionAvailable;
export const getServiceWorker = (state: AppState) => state.notification.serviceWorker;
